import {ChangeDetectorRef, Component, Inject} from '@angular/core';
import {MatButton} from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent, MatDialogTitle
} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";
import {NgForOf, NgIf} from "@angular/common";
import {MatDivider} from "@angular/material/divider";
import {MatTabsModule} from "@angular/material/tabs";
import {BreakpointObserver, BreakpointState} from "@angular/cdk/layout";

@Component({
    selector: 'app-dialog-wf-details-box',
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    TranslateModule,
    NgIf,
    NgForOf,
    MatDivider,
    MatTabsModule,
    MatDialogTitle
  ],
    templateUrl: './dialog-wf-details-box.component.html',
    styleUrl: './dialog-wf-details-box.component.scss',
  standalone: true
})
export class DialogWfDetailsBoxComponent {

  isSmallScreen: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { wfTaskDetails: any; wfDetails: any },
              private breakpointObserver: BreakpointObserver,
              private cdr: ChangeDetectorRef,)
  {
    this.breakpointObserver.observe([
      "(max-width: 768px)"
    ]).subscribe((result: BreakpointState) => {
      if(result.matches) {
        this.isSmallScreen = true;
        this.cdr.detectChanges();
      } else {
        this.isSmallScreen = false;
        this.cdr.detectChanges();
      }
    })
  }

  getworkflowDetails(){
    let details = [
      { label: 'ID', value: this.data.wfDetails.id },
      { label: 'CREATION_DATE', value: this.data.wfDetails.createDate },
      { label: 'CREATOR', value: this.data.wfDetails.creator },
      { label: 'TEMPLATE', value: this.data.wfDetails.templateName
          + ' (Ver. ' + this.data.wfDetails.templateVersion + ')' },
      { label: 'DEADLINE', value: this.data.wfDetails.deadline },
      { label: 'RESPONSIBLE_USER', value: this.data.wfDetails.responsibleUser.userName
          + ' - ' + this.data.wfDetails.responsibleUser.orgName },
      { label: 'RELATED_ITEM', value: this.data.wfDetails.relatedItem },
    ];
    return details.filter(item => item.label !== 'RELATED_ITEM' || item.value);
  }

  getTaskDetails(){
    let details = [
      { label: 'NAME', value:this.data.wfTaskDetails.taskName },
      { label: 'CREATION_DATE', value:this.data.wfTaskDetails.createDate },
      { label: 'EXECUTING_USER', value:this.data.wfTaskDetails.user + ' - ' +this.data.wfTaskDetails.org },
      { label: 'STATUS', value:this.data.wfTaskDetails.status },
      { label: 'RESULT', value:this.data.wfTaskDetails.result },
      { label: 'CLOSE_DATE', value:this.data.wfTaskDetails.closeDate }, //lezárás ideje
      { label: 'DEADLINE', value:this.data.wfTaskDetails.dueDate ?  this.data.wfTaskDetails.dueDate : null},
      { label: 'TYPE', value:this.data.wfTaskDetails.type },
    ];
    return details.filter(item => {
      if (this.data.wfTaskDetails.status === 'Új') {
        return !['RESULT', 'CLOSE_DATE'].includes(item.label);
      }
      if (this.data.wfTaskDetails.status === 'Átadva') {
        return item.label !== 'RESULT';
      }
      return true;
    });

  }

}
